import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

//styles
import { ImgQtc } from "./Qtc.elements";

//images
import qtc from "../../img/numeric/qtc/qtc.png";

export const Qtc = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <Link to="/settings/changenumeric">
      {!state.ecg ? (
        <ImgQtc src={qtc} style={{ opacity: "0" }} />
      ) : (
        <ImgQtc src={qtc} />
      )}
    </Link>
  );
};
